const axios = require('axios');

module.exports = axios.create({
    // baseURL: `https://${SERVER_URL}:${SERVER_PORT}/`,
    baseURL: `https://fbo.by/`,
});